import angular from 'angular';
import { keys, sample } from 'lodash';

// TODO(azirbel): Do we use this anymore? Can it be deleted?

module.exports = angular.module('market.directives.od-headline', [])
.directive('odHeadline', function odHeadline($location, $sce, Analytics) {
  var HEADLINES = {
    sold: '<b>Sold.</b> The minute you’re ready.',
    cash_today: 'Get a <b>cash offer</b> today.',
    market_prices: 'We make cash offers at <b>market prices</b>.',
    worth: 'What is my home worth?',
    unneeded_realtor: 'You don’t need a realtor.',
    sans_realtor: 'Sell your house without a realtor.',
    sans_agent: 'Sell your house without an agent.',
    sell_today: 'Sell your home <b>today</b>.',
    best_by_owner: 'The <b>best way</b> to sell by owner.',
    best_your_house: 'The <b>best way</b> to sell your house.'
  };

  var DIRECT_HEADLINES = [
    'sold' //, 'worth', 'sell_today', 'best_by_owner', 'best_your_house'
  ];

  return {
    // TODO(azirbel): Make this either a component (EA) or directive (A)
    // For now, assuming it's a directive
    restrict: 'C',
    link: function(scope, elem) {
      var x_headline = $location.search().x_headline;

      if (!HEADLINES.hasOwnProperty(x_headline))
        x_headline = sample(DIRECT_HEADLINES);
      if (!HEADLINES.hasOwnProperty(x_headline))
        x_headline = keys(HEADLINES)[0];

      elem.html($sce.trustAsHtml(HEADLINES[x_headline]));

      Analytics.register({ x_headline: x_headline });
    }
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/deprecated/od-headline.js
 **/